function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".cls-2{fill:#a166ff;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("title", null, "Elastic-Load-Balancing-ELB_Application-load-balancer_dark-bg");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Reference"
}, React.createElement("path", {
  className: "cls-2",
  d: "M25,50A25,25,0,1,1,50,25,25,25,0,0,1,25,50ZM25,2A23,23,0,1,0,48,25,23,23,0,0,0,25,2Z"
}), React.createElement("path", {
  className: "cls-2",
  d: "M39.9,32H38V28a1,1,0,0,0-1-1H34V23a1,1,0,0,0-1-1H26V19h7a1,1,0,0,0,1-1V9a1,1,0,0,0-1-1H17a1,1,0,0,0-1,1v9a1,1,0,0,0,1,1h7v3H17a1,1,0,0,0-1,1v4H13a1,1,0,0,0-1,1v4H10.1a1,1,0,0,0-1,1v5a1,1,0,0,0,1,1H15a1,1,0,0,0,1-1V33a1,1,0,0,0-1-1H14V29h5v3H18a1,1,0,0,0-1,1v5a1,1,0,0,0,1,1h5a1,1,0,0,0,1-1V33a1,1,0,0,0-1-1H21V28a1,1,0,0,0-1-1H18V24H32v3H30a1,1,0,0,0-1,1v4H27a1,1,0,0,0-1,1v5a1,1,0,0,0,1,1h5a1,1,0,0,0,1-1V33a1,1,0,0,0-1-1H31V29h5v3H34.93a1,1,0,0,0-1,1v5a1,1,0,0,0,1,1h5a1,1,0,0,0,1-1V33A1,1,0,0,0,39.9,32ZM14,37H11.1V34H14Zm8-3v3H19V34ZM18,17V10H32v7ZM31,37H28V34h3Zm7.9,0h-3V34h3Z"
}));

var SvgAwsElasticLoadBalancer = function SvgAwsElasticLoadBalancer(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    className: "svgCloudServices",
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? React.createElement("title", null, title) : null, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAwsElasticLoadBalancer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/AWS-Elastic_Load_Balancer.59a97a13.svg";
export { ForwardRef as ReactComponent };